<template>
  <div class="mc-videohistory-player__wrapper">
    <div class="mc-videohistory-player__top-detail">
      <div class="mc-videohistory-player__top-detail-items">
        <small class="mc-videohistory-player__top-detail-item-title">{{
          $t('videoHistory.video.numberPlate')
        }}</small>
        <p class="mc-videohistory-player__top-detail-item-value">
          {{ vehicleDetail?.licensePlate }}
        </p>
      </div>
      <div class="mc-videohistory-player__top-detail-items">
        <small class="mc-videohistory-player__top-detail-item-title">{{
          $t('videoHistory.video.vehicleType')
        }}</small>
        <p class="mc-videohistory-player__top-detail-item-value">
          {{ vehicleDetail?.vehicleType }}
        </p>
      </div>
      <div class="mc-videohistory-player__top-detail-items">
        <small class="mc-videohistory-player__top-detail-item-title">{{
          $t('videoHistory.video.vehicleCategory')
        }}</small>
        <p class="mc-videohistory-player__top-detail-item-value">
          {{ vehicleDetail?.vehicleCategory }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { mapGetters } from 'vuex'
import responsive from '@/mixin/responsive'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  name: 'VehicleDetail',
  mixins: [Helper, responsive, MixPanel],
  computed: {
    ...mapGetters('vehicle', ['vehicleId', 'vehicleDetail', 'vehicleVideoHistory', 'pickVideo']),
  },
  async created() {
    const vehicleId = Number(this.$route.params.vehicleId)

    if (this.pickVideo) {
      this.$store.dispatch('vehicle/updateStream', {
        index: this.pickVideo.index,
        indexVideo: this.pickVideo.indexVideo,
        status: 'DETACH_MEDIA',
      })
    }

    if (vehicleId !== this.vehicleId) {
      this.$store.commit('vehicle/clearVehicleId')
      this.$store.commit('vehicle/clearVehicleDetail')
      this.$store.commit('vehicle/clearVehicleVideos')
      this.$store.commit('vehicle/clearVideoStates')
      this.$store.commit('vehicle/clearPickVideo')
    }

    this.$store.commit('vehicle/setVehicleId', vehicleId)
  },
}
</script>
